import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useAlarmHistory } from '../lib/context/AlarmHistoryProvider';

const ToastListener = () => {
  const { addAlarmToHistory } = useAlarmHistory();
  const toastDataRef = useRef(new Map());

  useEffect(() => {
    const unsubscribe = toast.onChange((payload) => {
      const { id, status, content, type, data } = payload;

      // Store toast data when added
      if (status === 'added' && content) {
        toastDataRef.current.set(id, {
          id: id,
          type: type || 'default',
          content: content,
          timestamp: new Date().toISOString(),
          isAlarm: data?.isAlarm || false,
        });
      }

      // Add to history when toast is removed (only if it's an alarm)
      if (status === 'removed') {
        const toastData = toastDataRef.current.get(id);
        if (toastData?.isAlarm) {
          addAlarmToHistory(toastData);
        }
        toastDataRef.current.delete(id);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [addAlarmToHistory]);

  return null;
};

export default ToastListener;
